import { contactCard } from '../../shared';

export const buyersAgentCard = contactCard(
  'buySideContacts.buyersAgent',
  'agent',
);
